var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmarkSimple = function SvgIconBookmarkSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.513 3.263A1.75 1.75 0 0 1 6.75 2.75h10.5A1.75 1.75 0 0 1 19 4.5V21a1 1 0 0 1-1.53.848L12 18.429l-5.47 3.419A1 1 0 0 1 5 21V4.5c0-.464.184-.91.513-1.237M7 4.75v14.446l4.47-2.794a1 1 0 0 1 1.06 0L17 19.196V4.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBookmarkSimple;